


















































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import nodeWrap from './components/nodeWrap.vue';
import addNode from './components/addNode.vue';
import { deepClone } from '@/util/deepClone';
Vue.component('nodeWrap', nodeWrap); //初始化组件
Vue.component('addNode', addNode); //初始化组件

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function(el) {
    el.focus();
  },
});

@Component({
  components: {},
})
export default class ProcessDesign extends Vue {
  @Prop() private allForm: any;
  isTried: any = false;
  tipList: any = [];
  tipVisible: any = false;
  nowVal: any = 100;
  processConfig: any = {};
  nodeConfig: any = {};
  workFlowDef: any = {};
  flowPermission: any = [];
  directorMaxLevel: any = 0;
  dialogVisible: any = true;
  tableId: any = '';

  created() {
    const data = deepClone(this.allForm);
    // console.log(data.process.formData);
    // this.processConfig = {
    //   nodeConfig: {
    //     pid: '0',
    //     id: '0',
    //     type: 0,
    //     nodeName: '发起人',
    //     conditionNodes: [],
    //     conditionList: [],
    //     nodeUserList: [],
    //     formControlAuth: data.process.formData ? data.process.formData.start.formControlAuth : {},
    //     // formControlAuth: data.process.formData ? data.process.formData.nodeConfig.formControlAuth : {},
    //   },
    // };

    this.processConfig = data.process.formData || {
      nodeConfig: {
        pid: '0',
        id: '0',
        type: 0,
        nodeName: '发起人',
        conditionNodes: [],
        conditionList: [],
        nodeUserList: [],
        formControlAuth: data.process.formData ? data.process.formData.start.formControlAuth : {},
        // formControlAuth: data.process.formData ? data.process.formData.nodeConfig.formControlAuth : {},
      },
    };

    // const res = {
    //   code: '200',
    //   msg: 'success',
    //   data: {
    //     // tableId: 1,
    //     // workFlowVersionId: '',
    //     // workFlowDef: {
    //     //   name: '合同审批',
    //     //   publicFlag: 1,
    //     //   sortNo: 5,
    //     //   duplicateRemovelFlag: 1,
    //     //   optionTip: '',
    //     //   optionNotNull: 0,
    //     //   status: 1,
    //     // },
    //     // directorMaxLevel: 4,
    //     // flowPermission: [],
    //     nodeConfig: {
    //       pid: '0',
    //       id: '1',
    //       // pkId: 'sid-start-node',
    //       nodeName: '发起人',
    //       type: 0,
    //       // priorityLevel: '',
    //       // settype: '',
    //       // selectMode: '',
    //       // selectRange: '',
    //       // examineRoleId: '',
    //       // directorLevel: '',
    //       // replaceByUp: '',
    //       // examineMode: '',
    //       // noHanderAction: '',
    //       // examineEndType: '',
    //       // examineEndRoleId: '',
    //       // examineEndDirectorLevel: '',
    //       // ccSelfSelectFlag: '',
    //       conditionList: [],
    //       nodeUserList: [],
    //       // childNode: {
    //       //   nodeName: '审核人',
    //       //   error: false,
    //       //   type: 1,
    //       //   settype: 2,
    //       //   selectMode: 0,
    //       //   selectRange: 0,
    //       //   directorLevel: 1,
    //       //   replaceByUp: 0,
    //       //   examineMode: 1,
    //       //   noHanderAction: 2,
    //       //   examineEndDirectorLevel: 0,
    //       //   childNode: {
    //       //     nodeName: '路由',
    //       //     type: 4,
    //       //     priorityLevel: 1,
    //       //     settype: 1,
    //       //     selectMode: 0,
    //       //     selectRange: 0,
    //       //     examineRoleId: 0,
    //       //     directorLevel: 1,
    //       //     replaceByUp: 0,
    //       //     examineMode: 1,
    //       //     noHanderAction: 2,
    //       //     examineEndType: 0,
    //       //     examineEndRoleId: 0,
    //       //     examineEndDirectorLevel: 1,
    //       //     ccSelfSelectFlag: 1,
    //       //     conditionList: [],
    //       //     nodeUserList: [],
    //       //     childNode: {
    //       //       nodeName: '抄送人',
    //       //       type: 2,
    //       //       ccSelfSelectFlag: 1,
    //       //       childNode: null,
    //       //       nodeUserList: [],
    //       //       error: false,
    //       //     },
    //       //     conditionNodes: [
    //       //       {
    //       //         nodeName: '条件1',
    //       //         type: 5,
    //       //         priorityLevel: 1,
    //       //         settype: 1,
    //       //         selectMode: 0,
    //       //         selectRange: 0,
    //       //         examineRoleId: 0,
    //       //         directorLevel: 1,
    //       //         replaceByUp: 0,
    //       //         examineMode: 1,
    //       //         noHanderAction: 2,
    //       //         examineEndType: 0,
    //       //         examineEndRoleId: 0,
    //       //         examineEndDirectorLevel: 1,
    //       //         ccSelfSelectFlag: 1,
    //       //         conditionList: [
    //       //           {
    //       //             columnId: 0,
    //       //             type: 1,
    //       //             conditionEn: '',
    //       //             conditionCn: '',
    //       //             optType: '',
    //       //             zdy1: '',
    //       //             zdy2: '',
    //       //             opt1: '',
    //       //             opt2: '',
    //       //             columnDbname: '',
    //       //             columnType: '',
    //       //             showType: '',
    //       //             showName: '',
    //       //             fixedDownBoxValue: '',
    //       //           },
    //       //         ],
    //       //         nodeUserList: [
    //       //           {
    //       //             targetId: 85,
    //       //             type: 1,
    //       //             name: 'test',
    //       //           },
    //       //         ],
    //       //         childNode: {
    //       //           nodeName: '审核人',
    //       //           type: 1,
    //       //           priorityLevel: 1,
    //       //           settype: 1,
    //       //           selectMode: 0,
    //       //           selectRange: 0,
    //       //           examineRoleId: 0,
    //       //           directorLevel: 1,
    //       //           replaceByUp: 0,
    //       //           examineMode: 1,
    //       //           noHanderAction: 2,
    //       //           examineEndType: 0,
    //       //           examineEndRoleId: 0,
    //       //           examineEndDirectorLevel: 1,
    //       //           ccSelfSelectFlag: 1,
    //       //           conditionList: [],
    //       //           nodeUserList: [
    //       //             {
    //       //               targetId: 2515744,
    //       //               type: 1,
    //       //               name: '哈哈哈哈',
    //       //             },
    //       //           ],
    //       //           childNode: null,
    //       //           conditionNodes: [],
    //       //           error: false,
    //       //         },
    //       //         conditionNodes: [],
    //       //         error: false,
    //       //       },
    //       //       {
    //       //         nodeName: '条件2',
    //       //         type: 5,
    //       //         priorityLevel: 2,
    //       //         settype: 1,
    //       //         selectMode: 0,
    //       //         selectRange: 0,
    //       //         examineRoleId: 0,
    //       //         directorLevel: 1,
    //       //         replaceByUp: 0,
    //       //         examineMode: 1,
    //       //         noHanderAction: 2,
    //       //         examineEndType: 0,
    //       //         examineEndRoleId: 0,
    //       //         examineEndDirectorLevel: 1,
    //       //         ccSelfSelectFlag: 1,
    //       //         conditionList: [],
    //       //         nodeUserList: [],
    //       //         childNode: null,
    //       //         conditionNodes: [],
    //       //         error: false,
    //       //       },
    //       //     ],
    //       //   },
    //       //   nodeUserList: [],
    //       // },
    //       conditionNodes: [],
    //     },
    //   },
    // };
    // this.processConfig = res.data;
    this.nodeConfig = this.processConfig.nodeConfig;
    this.flowPermission = this.processConfig.flowPermission;
    this.directorMaxLevel = this.processConfig.directorMaxLevel;
    this.workFlowDef = this.processConfig.workFlowDef;
    this.tableId = this.processConfig.tableId;

    // if (data.process.formData) {
    //   this.setDataForm(data.process.formData);
    // }
    // this.setDataForm(data.process.formData);
  }
  mounted() {
    if (this.allForm.process) {
    }
  }

  setDataForm(data: any) {
    if (data.course.length > 0) {
      // this.processConfig.nodeConfig.childNode = this.arrayToTree(data.course);
      this.$set(this.processConfig.nodeConfig, 'childNode', this.arrayToTree(data.course));
    }
  }

  arrayToTree(list: any, callback: any = () => {}, props = { id: 'id', pid: 'pid', childNode: 'childNode' }) {
    let tree: any = {};
    const map: any = {};

    // list = cloneObj(list);

    const listLength = list.length;
    for (let i = 0; i < listLength; i++) {
      const node: any = list[i];

      if (node.type !== 1 && node.type !== 2 && node.type !== 3 && node.type !== 4) {
        // 节点类型转换
        const typeMap: any = {
          approve: 1,
          cope: 2,
          handle: 3,
          condition: 4,
        };
        node.nodeName = node.label;
        node.conditionNodes = [];
        node.conditionList = [];
        node.nodeUserList = [];

        const typeName = node.type;
        node.type = typeMap[typeName];

        if (node.conditionUnits && node.conditionUnits.length > 0) {
          node.conditionUnits.forEach((item: any, index: any) => {
            if (node.conditionUnits[index].flowNodes.length > 0) {
              node.conditionUnits[index].childNode = this.arrayToTree(node.conditionUnits[index].flowNodes);
            }
            node.conditionUnits[index].type = 5;
            node.conditionUnits[index].conditionNodes = [];
            node.conditionUnits[index].conditionList = [];
            node.conditionUnits[index].nodeUserList = [];
            node.conditionUnits[index].nodeName = item.name;
          });
        }

        node.conditionNodes = node.conditionUnits;
      }

      const nodeId: any = node[props.id];
      map[nodeId] = node;
      callback(node);
    }

    for (let i = 0; i < listLength; i++) {
      const node: any = list[i];
      const nodePid: any = node[props.pid];
      const parentNode: any = map[nodePid];
      if (parentNode) {
        parentNode[props.childNode] = parentNode[props.childNode] || {};
        parentNode[props.childNode] = node;
      } else {
        tree = node;
      }
    }

    return tree;
  }

  // methods: {
  toReturn() {
    //window.location.href = ""
  }
  reErr(data: any) {
    if (data.childNode) {
      if (data.childNode.type == 1) {
        //审批人
        if (data.childNode.error) {
          this.tipList.push({ name: data.childNode.nodeName, type: '审核人' });
        }
        this.reErr(data.childNode);
      } else if (data.childNode.type == 2) {
        if (data.childNode.error) {
          this.tipList.push({ name: data.childNode.nodeName, type: '抄送人' });
        }
        this.reErr(data.childNode);
      } else if (data.childNode.type == 3) {
        if (data.childNode.error) {
          this.tipList.push({ name: data.childNode.nodeName, type: '办理人' });
        }
        this.reErr(data.childNode.childNode);
      } else if (data.childNode.type == 4) {
        this.reErr(data.childNode);
        for (let i = 0; i < data.childNode.conditionNodes.length; i++) {
          if (data.childNode.conditionNodes[i].error) {
            this.tipList.push({ name: data.childNode.conditionNodes[i].nodeName, type: '条件' });
          }
          this.reErr(data.childNode.conditionNodes[i]);
        }
      }
    } else {
      data.childNode = null;
    }
  }
  saveSet() {
    this.isTried = true;
    // this.tipList = [];
    // this.reErr(this.nodeConfig);
    // if (this.tipList.length != 0) {
    //   this.tipVisible = true;
    //   return;
    // }
    // this.processConfig.flowPermission = this.flowPermission;
    // console.log(this.processConfig);
    // this.$axios.post("", this.processConfig).then(res => {
    //     if (res.code === '200') {
    //         this.$message.success("设置成功");
    //         setTimeout(function () {
    //             window.location.href = ""
    //         }, 200)
    //     }
    // })
  }
  zoomSize(type: any) {
    if (type == 1) {
      if (this.nowVal == 50) {
        return;
      }
      this.nowVal -= 10;
    } else {
      if (this.nowVal == 300) {
        return;
      }
      this.nowVal += 10;
    }
  }

  @Watch('processConfig', { deep: true })
  private getData() {
    const data = {
      formData: this.processConfig,
      type: 'process',
    };
    this.$emit('setData', data);
  }
}
